import { render, staticRenderFns } from "./PendingCertifications.vue?vue&type=template&id=485f154e&scoped=true"
import script from "./PendingCertifications.vue?vue&type=script&lang=js"
export * from "./PendingCertifications.vue?vue&type=script&lang=js"
import style0 from "./PendingCertifications.vue?vue&type=style&index=0&id=485f154e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f154e",
  null
  
)

export default component.exports